




import {Component, Vue, Prop} from 'vue-property-decorator';
import {Item} from "../model";
import KkImage from '@/components/KK-Image.vue';

@Component({
  components: { KkImage }
})
export default class ItemImage extends Vue {
  @Prop({default: new Item({})}) item!:Item;
  get imageKey (): string {
    return this.item.getImageKey();
  }
}
